import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpResponse, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class Interceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: (string|null) = localStorage.getItem('token');

    

    if (!token) {
      let headers = new HttpHeaders({
        'ngrok-skip-browser-warning': 'true'
      });
  
      // Clonez la requête et appliquez les en-têtes modifiés
      const modifiedRequest1 = httpRequest.clone({
          headers: headers
      });

        return next.handle(modifiedRequest1);
    }

    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'ngrok-skip-browser-warning': 'true'
    });

    // Clonez la requête et appliquez les en-têtes modifiés
    const modifiedRequest = httpRequest.clone({
        headers: headers
    });

    return next.handle(modifiedRequest);

  }
}
